import withSearch, { SearchProps } from "hocs/withSearch";
import { forwardRef } from "react";

import { ReactComponent as SearchIcon } from "assets/icons/search.svg";
import Box from "./Box";

const SearchField = forwardRef<HTMLInputElement, SearchProps>(
  ({ onKeyDown, onChange, onSearch }, ref) => {
    return (
      <Box className="flex-1 flex items-center gap-[0.625rem] !pl-5 !pr-[1.375rem] !py-[0.938rem]">
        <input
          ref={ref}
          type="text"
          className="placeholder:text-secondary w-full text-16 outline-none"
          placeholder="이름, 아이디로 검색 "
          onKeyDown={onKeyDown}
          onChange={onChange}
        />
        <button type="button" className="shrink-0" onClick={onSearch}>
          <SearchIcon className="size-6" />
        </button>
      </Box>
    );
  },
);

SearchField.displayName = "SearchField";

const EnhancedSearchField = withSearch(SearchField);

export default EnhancedSearchField;
